import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import {MessageService} from 'primeng/api';
import { CommonService } from 'src/app/services/common.service';
declare var MachnetWidget: any;
declare var selectedValue:any;
declare var replytype:any;
declare var webengage
@Component({
  selector: 'app-payment-method',
  templateUrl: './payment-method.component.html',
  styleUrls: ['./payment-method.component.scss']
})
export class PaymentMethodComponent implements OnInit {
  token ='';
  constructor(public auth:AuthService,private messageService: MessageService,public common:CommonService) { }
  
  ngOnInit(): void {
    webengage.track("payment_method_intiate",{
    })
    this.common.showLoader()
    this.auth.getWidgetToken().subscribe((res:any)=>{
      //console.log(res)
      this.token = res.token;
      this.common.stopLoader()
    },err=>{
      let errorKeys = Object.keys(err.error.errors); 
      errorKeys.forEach(key => { 
        //console.log(key)
        let value = err.error.errors[key][0]; 
        this.messageService.add({severity:'error', summary:value, detail:""});
        //console.log(value); 
    }); 
      //console.log(err)
      this.common.stopLoader()
    })
  }
  
  addScript(senderid,token,type){
    
    var widget = new MachnetWidget({
      elementId: "widget-root-type",
      senderId: senderid,
      width: "100%",
      height: "800px",
      fontSize:"14px",
      type: type,
      locale: "en",
      multiStep: true,
      stylesheet: "../../styles.scss",
      token: token,
    });
    widget.init();
    window.addEventListener("message", function (e) {
      webengage.track(`add_${type}` , {
        "Status" : 1
      })
      //console.log("type", e.data.type)
      //console.log("all_detail", e.data)
      //console.log("all", e)
      
    });
  }
  
  selectedType = 'opentype';
  bankShown = false ;
  cardShown: boolean = false ;
  onChange(event) {
    this.bankShown = false;
    this.selectedType = event.target.value;
    //console.log('hello');
    
  }
  onAddBank() {
    this.bankShown = true;
    this.addScript(this.auth.user.uuid,this.token, 'bank')
  }
  onAddCard() {
    this.bankShown = true;
    this.addScript(this.auth.user.uuid,this.token, 'card')
    
  }
  
}
